<template>
  <div
    class="nav-bar"
    :class="{'is-small': mini}"
    :style="`--width: ${mini ? 68 : 246}px; grid-template-rows: ${gridTemplateRows}; z-index: 10`">
    <slot name="headBlock"/>
    <div
      v-if="create_router_to"
      class="nav-bar__create">
      <sTooltip
        :border="false"
        :content="create_text"
        :disabled="!mini"
        type="dark">
        <slot
          :mini="mini"
          name="btnCreate"/>
        <sButton
          v-if="!$slots.btnCreate"
          class="px-auto"
          data-qa="btn-nav-bar"
          :icon="mini ? 'plus' : ''"
          :to="create_router_to">
          <span
            v-if="!mini"
            class="nav-bar__create-link"
            data-qa="btn-nav-bar-text">{{ create_text }}</span>
          <slot name="additional-in-btn"/>
        </sButton>
      </sTooltip>
    </div>
    <div
      class="nav-bar__content"
      data-qa="navbar-content"
      style="display: grid; grid-template-rows: 1fr auto;">
      <ScrollShadow
        class="height-100"
        :shadow-width="false">
        <NavBarListItem
          v-for="(typeItem, typeItemIndex) in types"
          :key="typeItemIndex + typeItemIndex"
          :active="activeMutated === typeItemIndex"
          :class="{
            's-list-item__active' : (typeItemIndex == activeMutated && mini ) ,
            'pl-7': typeItem.subcategory && !mini,
            [typeItem.class && !mini ? typeItem.class : '']: true
          }"
          :disabled="loading || disabled"
          :index="typeItemIndex"
          :item="typeItem"
          :items="items"
          :mini="mini"
          :show-count="showCount"
          @click="filterByTypes(typeItem)">
          <template #item_text>
            <slot
              :item="typeItem"
              :items="items"
              name="list_item"/>
          </template>
          <template #count>
            <slot
              :item="typeItem"
              :items="items"
              name="list_item_count"/>
          </template>
        </NavBarListItem>
        <div
          v-show="!mini">
          <slot
            name="additional_filters"/>
        </div>
        <slot name="additional"/>
      </ScrollShadow>
      <slot name="after_scroll"/>
    </div>
    <div
      class="nav-bar__footer">
      <ManagerCard v-show="!mini"/>
      <div
        class="nav-bar__footer-btn"
        :class="{'show-navBar': !mini}"
        data-qa="btn-menu-mini"
        @click="setSmallNavBar(!mini)">
        <sIcon
          class="my-auto mx-auto"
          :rotate="mini ? 180 : 0"
          size="10"
          type="double-arrow"/>
      </div>
    </div>
  </div>
</template>
<script>
import ScrollShadow from 'components/common/ScrollShadow.vue'
import ManagerCard from 'components/common/blocks/ManagerCard.vue'
import NavBarListItem from 'components/common/elements/NavBarListItem.vue'

import { filterSortMixin, filtersTemplatesMixin, storageMixin } from 'mixins'
import displaySize from 'mixins/display-size'

import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
  name: 'navBar',
  mixins: [ filterSortMixin, storageMixin, filtersTemplatesMixin, displaySize ],
  data() {
    return {
      mini: false
    }
  },
  methods: {
    setSmallNavBar(val) {
      this.mini = val
      this.$emit('update:mode', val)
      eventBus.$emit('changeSizeNavbar', val)
      this.$_savePropToDBStorage(`${this.$route.name}.mini`, val)
    },
    async loadData() {
      this.filterByTypes(this.types[this.active ])
    },
    filterByTypes(item) {
      this.$emit('changeFilter')
      // this.filterOpt.all = item?.all
      this.filterOpt.from_bar = item
      this.$emit('filterItems', item )

      this.filters = {
        ...this.filters,
        type: item.type,
        name: this.filters_type
      }
      this.$_saveFiltersToDBStorage({type: item.type})
    },
  },
  computed: {
    ...mapGetters({
      currentOrganization: 'getCurrentOrganization',
    }),
    gridTemplateRows() {
      const footerBlock = this.mini ? '75px' : '150px'
      if (this.create_router_to) {
        const createBlock = this.mini ? '75px' : '90px'
        return `${this.headBlockHeight || ''} ${createBlock} minmax(20px, 1fr) ${footerBlock}`
      }
      return `${this.headBlockHeight || ''} minmax(20px, 1fr) ${footerBlock}`
    },
    filterOpt: {
      get() {
        return this.filter || {}
      },
      set(value) {
        this.$emit('update:filter', value)
      }
    },
    miniMutable: {
      get() {
        return this.mode
      },
      set(value) {
        this.$emit('update:mode', value)
      }
    },
    filters: {
      get() {
        if ( this.filters_type ) {
          let filters_templates = this.$store.getters.getFilters || {}
          return filters_templates[this.filters_type] || []
        }
        return []
      },
      set(val) {
        if ( this.filters_type ) {
          this.$store.commit('setFilters', val)
        }
      }
    },
    activeMutated: {
      get: function () {
        return this.active
      },
      set: function (newValue) {
        this.$emit('update:active', newValue)
      }
    }
  },
  watch: {
    /*types(val, old) {
      if (val.length != old.length && old) {
        this.setActive()
      }
    },*/
    loading() {
      if (!this.unload) {
        this.loadData()
      }
    },
  },
  props: {
    filter: Object,
    types: Array,
    items: Array,
    loading: Boolean,
    disabled: Boolean,
    unload: Boolean,
    /**
     * текст кнопки создания и подсказки
     */
    create_text: String,
    /**
     * Ссылка на создание
     */
    create_router_to: Object,
    active: {
      type: Number,
      default: 0,
    },
    /** Свернутый режим */
    mode: {
      type: Boolean,
    },
    /**
     * Высота блока заголовка
     */
    headBlockHeight: {
      type: String,
    },
    showCount: {
      type: Boolean,
      default: true,
    },
  },
  async created() {
    this.$nextTick(() => {
      this.$el.style.transform = null
    })
  },
  mounted() {
    if (this.breakpoint.smAndDown) {
      this.setSmallNavBar(true)
    } else {
      this.$_getPropFromDBStorage(`${this.$route.name}.mini`, false)
        .then((result) => {
          this.setSmallNavBar(result)
        })
    }
  },
  components: {
    ManagerCard,
    ScrollShadow,
    NavBarListItem
  }
}
</script>
<style lang="scss" scoped>
$create-height: 93px;

.nav-bar {
  $nav-bar: &;
  display: grid;
  width: var(--width);
  min-width: var(--width);
  //overflow: hidden;
  height: calc(100vh - 64px);
  background-color: var(--v-main__light_green-base);
  transition: all 0.25s;
  @media (max-width: 935px) {
    position: absolute;
    z-index: 1;
    top: 0;
    bottom: 0;
    box-shadow: 1px 1px 4px -2px black !important;
  }
  &__content,
  &__footer {
    width: var(--width);
    transition: all 0.25s;
  }
  &__create {
    padding-top: 30px;
    padding-bottom: 20px;
    &-link {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: .03em;
      height: 40px;
    }
  }
  &__footer {
    display: grid;
    overflow: hidden;
    transition: all 0.25s;
    //grid-template-columns: minmax(20px, 1fr) 55px;
    &-btn {
      //transition: all 0.25s;
      //margin: auto auto 15px;

      position: absolute;
      left: 52px;
      bottom: 10px;
      z-index: 10;
      background: var(--v-secondary__green_chosen-base);
      width: 30px;
      height: 30px;
      line-height: 1;
      border-radius: 50px;
      cursor: pointer;
      display: flex;
      transition: all 0.25s;
      border: 2px solid var(--v-main__green-base) !important;
      &.show-navBar {
        left: calc(var(--width) - 15px);
      }
    }
  }

  &.is-small {
    width: var(--width);
    min-width: var(--width);
    #{$nav-bar}__footer {
      grid-template-columns: var(--width);
    }
    #{$nav-bar}__create {
      padding-top: 15px;
      padding-bottom: 5px;
    }
  }
}


/*.mini-list-item {
  width: 34px;
  min-height: 34px;
  height: 34px;

  .v-list-item__icon, .v-list-item__icon img {
    height: 16px;
    min-height: 16px;
    width: 16px;
    min-width: 15px;
  }
}

.list-enter-active, .list-leave-active {
  transition: all 0.4s;
}*/
</style>
<style lang="scss">
/*.navbar {
  position: inherit !important;
  &__list {
    width: 100%;
    min-height: 34px;
    padding: 8px 0;
    position: static;
    transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .v-navigation-drawer__content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  &__main-content {
    overflow: auto;
  }
  transition: all 0.25s;
  transition-property: max-width;
  position: sticky;
  top: 65px;

  transition: all 0.25s;
  transition-property: width;

  height: calc( 100vh - 65px) !important;
  overflow: auto;
  .departments-list {
    font-size: 12px;

    .subheader {
      font-size: 10px;
      height: 12px;
    }
  }
  .type-item, .department-item {
    padding-bottom: 4px;
    &.active {
      padding-bottom: 0px;
    }
  }*/
  .type-name {
    color: var(--text-color);
    line-height: 24px;
    cursor: pointer;
    overflow-wrap: anywhere;
    .divider {
      border: 2px solid var(--black-color) !important;
    }
  }
  .type-count {
    font-size: 12px;
    line-height: 24px;
    color: var(--text-color);
    opacity: 0.5;
  }
  .types-list {
    font-size: 15px;
    font-weight: 500;
  }
  /*.create {
    height: 93px;
    min-height: 93px;
    .chip {
      background: var(--black-color);
      color: var(--white-color);
      font-weight: 400;
      line-height: 20px;
      font-size: 14px;
      border-radius: 37px;
    }
    .create-new {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.03em;
      height: 40px;
      &.v-btn--icon {
        width: 40px;
      }
    }
  }
  .v-navigation-drawer__border {
    background-color: transparent !important ;
  }
  .v-list-group__header {
    padding: 0;
  }
  .mini-list-group .v-list-group__header {
    padding: 0;
    margin: 0 16px;
  }
  .v-list-group__header__append-icon, .v-list-item span{
    display: none;
  }
  .v-list-item--active {
    background-color: var(--v-secondary__green_chosen-base) ;
    &.v-list-item--link:before {
      background: transparent ;
    }
  }
  .v-list-item:hover::before {
    opacity: 0;
  }
} */
</style>
